import escapeStringRegexp from 'escape-string-regexp';
import React from 'react';

// TODO: presunut do nike-ui, nahradit replaceInString
export function replacePlaceholdersInString(text: string, placeholderReplaceMap: Record<string, () => JSX.Element>) {
    if (!placeholderReplaceMap || !Object.keys(placeholderReplaceMap).length) {
        return text;
    }

    const regex = new RegExp(
        `(${Object.keys(placeholderReplaceMap)
            .map(escapeStringRegexp)
            .join('|')})`,
        'g'
    );

    const children = text.split(regex).map((textChunk, index) => {
        if (placeholderReplaceMap[textChunk]) {
            const Component = placeholderReplaceMap[textChunk];
            return <Component key={index} />;
        }
        return <span key={index}>{textChunk}</span>;
    });

    return <span>{children}</span>;
}
